import {InformationCircleIcon} from "@heroicons/react/24/outline";
import ButtonPopup from "../../components/buttons/ButtonPopup.tsx";
import Popup, {IPopupRef} from "../../components/popups/Popup.tsx";
import {useContext, useRef, useState} from "react";
import {AppMainStateContext} from "../../contexts/AppMainStateContext.tsx";
import {VideoQualityLevelPreference} from "../../services/appStateService.ts";
import UtilsHelper from "../../helpers/utilsHelper.ts";
import {PopupItemButton} from "../../components/popups/PopupItemButton.tsx";
import AccountLayout from "../../components/layouts/AccountLayout.tsx";

const qualityItems: { key: VideoQualityLevelPreference, name: string }[] = [
    {key: "AUTO", name: "Auto"},
    {key: "LOW", name: "Najniższa"},
    {key: "BEST", name: "Najwyższa"},
]

const AccountPlayerSettingsPage = () => {
    // const _appState = new AppStateService().;
    UtilsHelper.changeWindowDocumentTitle("Ustawienia odtwarzacza");
    const [isOpen, setIsOpen] = useState(false);
    const {appStates, setVideoQualityPreference} = useContext(AppMainStateContext);
    const popupRef = useRef<IPopupRef>(null);
    const handleClickChangeSelectedItem = (key: VideoQualityLevelPreference) => {
        setVideoQualityPreference(key);
        if (isOpen && popupRef.current)
            popupRef.current.closePopup();
    }
    return (
        <AccountLayout>
            <div className={"bg-neutral-900 p-6 md:p-10 max-w-lg rounded-3xl"}>
                <h2 className={"text-xl"}>Domyślna jakość obrazu</h2>
                <div className={"flex max-w-md items-center space-x-3 my-4 text-neutral-400"}>
                    <p className={"text-sm"}>Wybierz preferowaną przez siebie jakość obrazu. Ustawienie będzie
                        zastosowane przy każdym przełączanym kanale. W przypadku opcji auto (domyślna) jakość będzie
                        dostosowana do jakości połączenia internetowego.</p>
                    <InformationCircleIcon className={"w-7 h-7 shrink-0"}/>
                </div>
                <div className={"relative show-element-animation-ease-in-out"}>
                    <ButtonPopup
                        className={"min-w-28 min-h-9"}
                        isOpen={isOpen}
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        {qualityItems.find(x => x.key === appStates.qualityLevelPreference)?.name || qualityItems[0].key}
                    </ButtonPopup>
                    <Popup isOpen={isOpen} ref={popupRef} title={"Wybierz jakość"}
                           className={"shadow-3xl shadow-neutral-800"}
                           setIsOpen={() => setIsOpen(!isOpen)}>
                        {qualityItems.map((item, index) => <PopupItemButton
                            id={item.name}
                            key={index}
                            disabled={appStates.qualityLevelPreference === item.key}
                            handleClick={() => handleClickChangeSelectedItem(item.key)}
                        >{item.name}</PopupItemButton>)}
                    </Popup>
                </div>
            </div>
        </AccountLayout>
    );
};

export default AccountPlayerSettingsPage;